import { useState } from "react";
import ModalViewAb from '_utils/ModalViewAb'
import CompanyAboutSection from 'components/company/companyAboutSection';


export default function ReadMore({ companyinfo , text, limit = 150 }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [open, setOpen] = useState(false);

  const openPopup = () => {
    setOpen(true);
  };
  //const toggle = () => setIsExpanded(!isExpanded);

  return (
    <>
    {text?
    <div>
      <p className="">
        {isExpanded ? text : text.substring(0, limit) + "..."}
      </p>

      <button
        onClick={openPopup}
        className="text-accent font-medium mt-1 hover:underline"
      >
        {open ? "Show Less" : "Show More"}
      </button>
    </div>
    :
    null 
    }
     <ModalViewAb open={open} onClose={() => setOpen(false)}>
        <div className="flex flex-col justify-center w-full">
              <CompanyAboutSection companyinfo={companyinfo} onClose={() => setOpen(false)} />
          </div>  
       {/* <LoginwithEmail goTo={window.location.href} />
        <SocialLogin mode='Login' user_type='user' goTo={window.location.href} />
        */}
      </ModalViewAb>
    </>
  );
}
